import { ChangeDetectionStrategy, Component, Input, inject, computed, signal } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { ApiService } from 'src/api/api.service';
import { TranslationService } from '../../layout/service/translation.service';

@Component({
    selector: 'app-page-header',
    standalone: true,
    imports: [CommonModule, TitleCasePipe],
    templateUrl: './page-header.component.html',
    styleUrl: './page-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent {
    private api = inject(ApiService);
    translationService = inject(TranslationService);
    t = computed(() => this.translationService.t());
    statusData = this.api.statusData;
    connectionStatus = this.api.connectionStatus;
    apiInitialized = this.api.initialized;

    @Input() set title(value: string | null | undefined) {
        this._title.set(value ?? null);
    }
    private _title = signal<string | null>(null);

    /** Resolve translated title: looks up 'page.<title>' key automatically */
    displayTitle = computed(() => {
        const title = this._title();
        if (!title) return this.statusData()?.systemName;
        return this.translationService.translatePageTitle()(title);
    });
}
